import { useEffect } from 'react';
import { navigate } from 'gatsby';

export default () => {
      useEffect(() => {
            navigate('/waist/');
      }, []);
      return null;
};